export const getGroupId = () => Number(localStorage.getItem("groupId") || "1");
export const getLibraryId = () =>
  Number(localStorage.getItem("libraryId") || "1");
export const getWebkey = () => localStorage.getItem("webKey") || "";
export const getFingerprint = () => localStorage.getItem("fingerprint") || "";
